/**
 * is body scroll lock
 * @param isLock
 */
export const isBodyScrollLock = (isLock = false) => {
  if (isLock) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = ''
  }
}
